import { animation, availableAnimations } from "@global/global-animation";

export const tabsWithImages = {
    initToggle: () => {
        const tabHeads = document.querySelectorAll(`.tabs-with-image--js-toggle .tab-links--head`);
        tabHeads.forEach(head => {
            head.addEventListener('click', (e) => {
                e.target.closest(`.tab-links--head`).classList.toggle('show');
                const icon = e.target.closest(`.tab-links--head`).querySelector('.button--icon');
                icon.classList.toggle('icon--arrow-up');
                icon.classList.toggle('icon--arrow-down');
            });
        });
    },
    initTabs: () => {
        const tabs = document.querySelectorAll(`.tabs-with-image--js-tabs`);
        tabs.forEach(tab => {
            tab.addEventListener('click', e => {
                e.preventDefault();
                if (document.querySelector('.tab-link--active')) {
                    document.querySelector('.tab-link--active').classList.remove('tab-link--active');
                }
                const link = e.target.closest('.tab-link');
                link.classList.add('tab-link--active');
                document.querySelector('.tab-links--head h2').innerText = link.innerText;
                const tabLink = e.target.closest('li');
                const oldActive = document.querySelector('.tab-content--active');
                const newActive = document.getElementById(tabLink.dataset.tab);

                if (document.querySelector('.tab-links--head')) {
                    document.querySelector('.tab-links--head').classList.remove('show');
                }

                animation.addAnimation(oldActive, availableAnimations.fades.fadeOut, "300ms",[
                    {
                        eventType: 'animationend',
                        eventCallback: (e) => {
                            e.target.classList.remove('tab-content--active');
                            newActive.classList.add('tab-content--active');
                            animation.addAnimation(newActive, availableAnimations.fades.fadeIn, "300ms");
                        }
                    }])
            });
        });
    }
};
